import { render, staticRenderFns } from "./5Step.vue?vue&type=template&id=0c57eba5&scoped=true&"
import script from "./5Step.vue?vue&type=script&lang=js&"
export * from "./5Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57eba5",
  null
  
)

export default component.exports